import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import { customStyles } from '../../../../helpers/modal_styles';
import { onEditarTipoMembresia } from '../../../../services/tipo-membresias/tipoMembresiaService';
import './TipoMembresiasEditModal.css';

export const TipoMembresiasEditModal = ({
    setModalEditar,
    modalEditar,
    editar,
    onReload
}) => {
    const dispatch = useDispatch();
    Modal.setAppElement("#root");

    const [formValues, setFormValues] = useState({
        id: '',
        membresia: '',
        descripcion: '',
        url_compra: '',
        max_auxiliares: 0,
        max_clientes: 0
    });

    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (editar && editar.id) {
            setFormValues({
                id: editar.id,
                membresia: editar.membresia,
                descripcion: editar.descripcion || '',
                url_compra: editar.url_compra || '',
                max_auxiliares: editar.max_auxiliares,
                max_clientes: editar.max_clientes
            });
            setErrors({});
        }
    }, [editar]);

    const closeModal = () => {
        setModalEditar(false);
        setErrors({});
    };

    const validateFields = () => {
        const newErrors = {};

        if (!formValues.max_auxiliares && formValues.max_auxiliares !== 0) {
            newErrors.max_auxiliares = 'Este campo es requerido';
        } else if (formValues.max_auxiliares < 0) {
            newErrors.max_auxiliares = 'Debe ser un número positivo';
        }

        if (!formValues.max_clientes && formValues.max_clientes !== 0) {
            newErrors.max_clientes = 'Este campo es requerido';
        } else if (formValues.max_clientes < 0) {
            newErrors.max_clientes = 'Debe ser un número positivo';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateFields()) {
            return;
        }

        try {
            const resultado = await dispatch(
                onEditarTipoMembresia(
                    formValues.id,
                    parseInt(formValues.max_auxiliares),
                    parseInt(formValues.max_clientes),
                    formValues.descripcion,
                    formValues.url_compra
                )
            );

            if (resultado) {
                closeModal();
                onReload();
            }
        } catch (error) {
            console.log('Error:', error);
            Swal.fire('Error', 'Error al guardar los cambios', 'error');
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormValues({
            ...formValues,
            [name]: (name === 'descripcion' || name === 'url_compra') ? value : (value === '' ? '' : parseInt(value))
        });
    };

    return (
        <Modal
            isOpen={modalEditar}
            onRequestClose={closeModal}
            style={customStyles}
            contentLabel="Editar Tipo de Membresía"
        >
            <div className="popup">
                <center>
                    <h3>Editar Tipo de Membresía</h3>
                </center>
                <br />
                <form onSubmit={handleSubmit}>
                    <div className="form-group-custom">
                        <label><strong>Nombre del Plan</strong></label>
                        <input
                            type="text"
                            className="input-custom"
                            value={formValues.membresia || ''}
                            disabled
                        />
                        <small>Solo lectura</small>
                    </div>

                    <div className="form-group-custom">
                        <label><strong>Descripción</strong></label>
                        <textarea
                            name="descripcion"
                            className="input-custom"
                            value={formValues.descripcion || ''}
                            onChange={handleInputChange}
                            rows="4"
                            style={{ resize: 'vertical' }}
                        />
                    </div>

                    <div className="form-group-custom">
                        <label><strong>URL de Compra</strong></label>
                        <input
                            type="text"
                            name="url_compra"
                            className="input-custom"
                            value={formValues.url_compra || ''}
                            onChange={handleInputChange}
                            placeholder="https://ejemplo.com/planes/basico"
                        />
                    </div>

                    <div className="form-row-custom">
                        <div className="form-group-custom">
                            <label><strong>Máximos Auxiliares</strong></label>
                            <input
                                type="number"
                                name="max_auxiliares"
                                className={`input-custom ${errors.max_auxiliares ? 'input-error' : ''}`}
                                value={formValues.max_auxiliares}
                                onChange={handleInputChange}
                                min="0"
                            />
                            {errors.max_auxiliares && (
                                <div className="error-message">
                                    {errors.max_auxiliares}
                                </div>
                            )}
                        </div>
                        <div className="form-group-custom">
                            <label><strong>Máximos Clientes</strong></label>
                            <input
                                type="number"
                                name="max_clientes"
                                className={`input-custom ${errors.max_clientes ? 'input-error' : ''}`}
                                value={formValues.max_clientes}
                                onChange={handleInputChange}
                                min="0"
                            />
                            {errors.max_clientes && (
                                <div className="error-message">
                                    {errors.max_clientes}
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="button-group">
                        <button type="submit" className="btn-save">
                            Guardar
                        </button>
                        <button type="button" className="btn-cancel" onClick={closeModal}>
                            Cancelar
                        </button>
                    </div>
                </form>
            </div>
        </Modal>
    );
};
